import React from "react";
import { COLORS } from "../../theme";
import Icon from "./Icon";

// Substitui o "Nenhum X ainda" de texto puro por um ícone + texto centralizado —
// mesmo texto de antes em cada tela, só com uma pista visual do que falta.
export default function EstadoVazio({ icon, texto, acao }) {
  return (
    <div style={{ padding: "40px 24px", display: "flex", flexDirection: "column", alignItems: "center", gap: 12, textAlign: "center" }}>
      {icon && (
        <div style={{ width: 44, height: 44, borderRadius: "50%", background: COLORS.bg, display: "flex", alignItems: "center", justifyContent: "center", color: COLORS.textLight }}>
          <Icon name={icon} size={20} />
        </div>
      )}
      <div style={{ fontSize: 13.5, color: COLORS.textMid }}>{texto}</div>
      {acao}
    </div>
  );
}
